import React from 'react';
import { SdfBox, SdfQuickStat, SdfRadioButton, SdfRadioGroup } from '@synerg/react-components';
import usFlag from '../../assets/wizard-flags/us-flag-one-group.svg';
import caFlag from '../../assets/wizard-flags/ca-one-group.svg';

function StepTwo({ state = {}, dispatch, isDataCloudProject, control, selectedRadioBtnIndex, setSelectedRadioBtnIndex }) {
	const dtrum = global.window.dtrum;

	const onStoreChange = ev => {
		dispatch({ type: 'UPDATE', payload: { appStore: ev } });
		if (ev === 'CA') {
			const actionId = dtrum?.enterAction('marketplace_integration_ca', 'button');
    		console.log('Dtrum action id on marketplace integration canada selection - ', actionId);
			dispatch({ type: 'UPDATE', payload: { companySize: 'mid', useCaseID: null } });
			setSelectedRadioBtnIndex(1);
			dtrum?.leaveAction(actionId);
		}
		if (ev === 'US') {
			const actionId = dtrum?.enterAction('marketplace_integration_us', 'button');
    		console.log('Dtrum action id on marketplace integration us selection - ', actionId);
			setSelectedRadioBtnIndex(0);
			dtrum?.leaveAction(actionId);
		}
	};

	return (
		<div className="mt-8" style={{height: "34rem"}}>
			<div className="text-heading-05 font-bold mb-4">Marketplace integration</div>
			<div className="text-body-02 mb-6">Select a Marketplace site below for which you desire to build an integration.</div>

			<div className="text-heading-05 font-bold mb-8">On which ADP Marketplace site do you plan to list your integration?</div>

			<div className="items-center justify-center pb-12">
				<SdfRadioGroup direction="row">
					<SdfBox
						variant="bordered"
						spacing="default"
						className={selectedRadioBtnIndex === 0 ? 'border-action-primary max-h-xs' : 'max-h-xs'}>
						<div onClick={() => { onStoreChange('US') }}>
							<div className='flex text-sm mb-4'>
								<SdfRadioButton value="US" checked={0 === selectedRadioBtnIndex}/>
							</div>
							<img className="mb-12 px-12" alt="US flag" src={usFlag} />
						</div>
						<div className="flex center justify-center">
							<div className="text-heading-03 font-bold">U.S Marketplace</div>
						</div>
					</SdfBox>

					<SdfBox
						className={selectedRadioBtnIndex === 1 ? 'border-action-primary max-h-xs p-4' : 'max-h-xs p-4'}
						variant="bordered"
						spacing="default"
					>
						<SdfQuickStat size="sm" labelPosition={'bottom'} onClick={() => { onStoreChange('CA') }}>
							<div className='flex text-md mb-2'>
								<SdfRadioButton value="CA" checked={1 === selectedRadioBtnIndex} />
							</div>
							<img className="mb-12 px-12" alt="Canada flag" src={caFlag} />
						</SdfQuickStat>
						<div className="flex center justify-center pb-4">
							<div className="text-heading-03 font-bold">Canadian Marketplace</div>
						</div>
					</SdfBox>
				</SdfRadioGroup>
			</div>
		</div>
	)
}

export default StepTwo;
